<template>
    <div>
        <div class="header-financiar">
            <div class="inner-header-financiar container">
                <div @click="updateActualView('homeView')" class="logo-background"></div>
                <div class="menu-header">
                    <span>· Hacé crecer tu idea ·</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapActions} from 'vuex';

    export default {
        data() {
            return {};
        },

        methods: {
            ...mapActions(['updateActualView']),

        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .header-financiar {
        background-color:white;
        padding-top: 45px;
        padding-bottom: 30px;
        box-shadow: 0 3px 8px 0 rgba(149,148,148,0.5);

        .inner-header-financiar{
            background-color:#FFFFFF;
            width: 100%;
            display: flex;
            align-items: center;
            /*justify-content: space-between;*/

            .logo-background {
                background-image: url('~@/assets/img/base/logo.png');
                width: 135px;
                height: 45px;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                cursor: pointer;
            }

            .menu-header{
                span{
                    border-bottom: 3px solid transparent;
                    /*padding-bottom:5px;*/
                    color: #4285F4;
                    font-weight: 500;
                    margin-left: 25px;
                    /*text-transform: uppercase;*/
                    font-size: 18px;
                    /*padding-top: 15px;*/
                    display: inline-block;
                    font-style: italic;
                    font-family: 'Montserrat', sans-serif;
                    /*&:hover{*/
                        /*cursor: pointer;*/
                        /*border-bottom: 3px solid #4285F4;*/
                    /*}*/
                }
                @include sm(){
                    text-align: center;
                }
            }
        }




    }

</style>